import React, { useState, useEffect } from 'react';
import RichTextEditor from './RichTextEditor';
import { useNavigate } from 'react-router-dom';
import SideBar from './DashBoard/SideBar';
import Navbar from './DashBoard/Navbar';
import { API_BASE_URL } from '../config/api';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faChalkboardUser,
  faTag,
  faAlignLeft,
  faVideo,
  faImage,
  faArrowLeft,
  faCheckCircle,
  faSpinner,
  faExclamationCircle,
  faLayerGroup
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

function AddCourse() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    courseName: '',
    tutor: '',
    price: '',
    description: '',
    video: '',
    photo: '',
    category_id: '',
  });

  useEffect(() => {
    if (!localStorage.getItem("adminId")) {
      navigate("/admin-login");
    }
    // Fetch categories for dropdown
    fetch(`${API_BASE_URL}/api/categories`)
      .then((res) => res.json())
      .then((data) => setCategories(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.category_id) {
      setError('Please select a category for this course.');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/courses`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200 || response.status === 201 || response.ok) {
        toast.success("Course added successfully!");
        navigate("/DCourses");
      } else {
        const data = await response.json();
        setError(data.error || "Failed to add course.");
      }
    } catch (err) {
      setError('Course creation error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      <SideBar current={"courses"} />
      <section id="content">
        <Navbar />
        <main style={{ padding: "28px", maxWidth: "900px", margin: "0 auto" }}>

          {/* Header */}
          <div style={{ marginBottom: "28px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <button
                onClick={() => navigate("/DCourses")}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#4f46e5",
                  fontWeight: 700,
                  fontSize: "0.9rem",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  marginBottom: "8px",
                  padding: 0
                }}
              >
                <FontAwesomeIcon icon={faArrowLeft} /> Back to Courses
              </button>
              <h1 style={{ color: "#0f172a", fontFamily: "'Outfit', sans-serif", fontSize: "1.8rem", fontWeight: 800, margin: 0 }}>
                Add New Course
              </h1>
              <p style={{ color: "#64748b", margin: "4px 0 0", fontSize: "0.9rem" }}>
                Create a new curriculum module and publish it to students
              </p>
            </div>
          </div>

          {/* Form Card */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "20px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.05)",
              padding: "36px",
              animation: "fadeIn 0.4s ease-out"
            }}
          >
            {error && (
              <div
                style={{
                  background: "#fef2f2",
                  border: "1px solid #fecaca",
                  color: "#ef4444",
                  padding: "14px 18px",
                  borderRadius: "12px",
                  fontSize: "0.9rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "24px"
                }}
              >
                <FontAwesomeIcon icon={faExclamationCircle} />
                <span>{error}</span>
              </div>
            )}

            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              {/* Row 1: Course Name & Instructor */}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "20px" }}>
                <div>
                  <label style={{ display: "block", color: "#334155", fontSize: "0.88rem", fontWeight: 700, marginBottom: "8px" }}>
                    Course Title *
                  </label>
                  <div style={{ position: "relative" }}>
                    <FontAwesomeIcon icon={faBook} style={{ position: "absolute", left: "16px", top: "50%", transform: "translateY(-50%)", color: "#94a3b8" }} />
                    <input
                      type="text"
                      name="courseName"
                      placeholder="e.g. Master Fullstack Web Development"
                      value={formData.courseName}
                      onChange={handleChange}
                      required
                      style={{
                        width: "100%",
                        padding: "12px 16px 12px 44px",
                        border: "1.5px solid #cbd5e1",
                        borderRadius: "12px",
                        fontSize: "0.95rem",
                        color: "#0f172a",
                        outline: "none",
                        boxSizing: "border-box"
                      }}
                    />
                  </div>
                </div>

                <div>
                  <label style={{ display: "block", color: "#334155", fontSize: "0.88rem", fontWeight: 700, marginBottom: "8px" }}>
                    Instructor / Tutor Name *
                  </label>
                  <div style={{ position: "relative" }}>
                    <FontAwesomeIcon icon={faChalkboardUser} style={{ position: "absolute", left: "16px", top: "50%", transform: "translateY(-50%)", color: "#94a3b8" }} />
                    <input
                      type="text"
                      name="tutor"
                      placeholder="e.g. Dr. Alex Johnson"
                      value={formData.tutor}
                      onChange={handleChange}
                      required
                      style={{
                        width: "100%",
                        padding: "12px 16px 12px 44px",
                        border: "1.5px solid #cbd5e1",
                        borderRadius: "12px",
                        fontSize: "0.95rem",
                        color: "#0f172a",
                        outline: "none",
                        boxSizing: "border-box"
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Row 2: Price & Category */}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "20px" }}>
                <div>
                  <label style={{ display: "block", color: "#334155", fontSize: "0.88rem", fontWeight: 700, marginBottom: "8px" }}>
                    Course Price ($ USD) *
                  </label>
                  <div style={{ position: "relative" }}>
                    <FontAwesomeIcon icon={faTag} style={{ position: "absolute", left: "16px", top: "50%", transform: "translateY(-50%)", color: "#94a3b8" }} />
                    <input
                      type="number"
                      name="price"
                      placeholder="e.g. 49"
                      value={formData.price}
                      onChange={handleChange}
                      required
                      style={{
                        width: "100%",
                        padding: "12px 16px 12px 44px",
                        border: "1.5px solid #cbd5e1",
                        borderRadius: "12px",
                        fontSize: "0.95rem",
                        color: "#0f172a",
                        outline: "none",
                        boxSizing: "border-box"
                      }}
                    />
                  </div>
                </div>

                <div>
                  <label style={{ display: "block", color: "#334155", fontSize: "0.88rem", fontWeight: 700, marginBottom: "8px" }}>
                    Category *
                    <span style={{ color: "#ef4444", fontSize: "0.78rem", marginLeft: "6px", fontWeight: 600 }}>(Required)</span>
                  </label>
                  <div style={{ position: "relative" }}>
                    <FontAwesomeIcon icon={faLayerGroup} style={{ position: "absolute", left: "16px", top: "50%", transform: "translateY(-50%)", color: "#94a3b8", zIndex: 1 }} />
                    <select
                      name="category_id"
                      value={formData.category_id}
                      onChange={handleChange}
                      required
                      style={{
                        width: "100%",
                        padding: "12px 16px 12px 44px",
                        border: "1.5px solid #cbd5e1",
                        borderRadius: "12px",
                        fontSize: "0.95rem",
                        color: formData.category_id ? "#0f172a" : "#94a3b8",
                        outline: "none",
                        boxSizing: "border-box",
                        background: "#fff",
                        appearance: "auto",
                        cursor: "pointer"
                      }}
                    >
                      <option value="">— Select a Category —</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>{cat.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* Row 3: Video Link */}
              <div>
                <label style={{ display: "block", color: "#334155", fontSize: "0.88rem", fontWeight: 700, marginBottom: "8px" }}>
                  Video Embed / YouTube URL *
                </label>
                <div style={{ position: "relative" }}>
                  <FontAwesomeIcon icon={faVideo} style={{ position: "absolute", left: "16px", top: "50%", transform: "translateY(-50%)", color: "#94a3b8" }} />
                  <input
                    type="text"
                    name="video"
                    placeholder="https://www.youtube.com/watch?v=..."
                    value={formData.video}
                    onChange={handleChange}
                    required
                    style={{
                      width: "100%",
                      padding: "12px 16px 12px 44px",
                      border: "1.5px solid #cbd5e1",
                      borderRadius: "12px",
                      fontSize: "0.95rem",
                      color: "#0f172a",
                      outline: "none",
                      boxSizing: "border-box"
                    }}
                  />
                </div>
              </div>

              {/* Row 4: Image Link */}
              <div>
                <label style={{ display: "block", color: "#334155", fontSize: "0.88rem", fontWeight: 700, marginBottom: "8px" }}>
                  Course Cover Image URL *
                </label>
                <div style={{ position: "relative" }}>
                  <FontAwesomeIcon icon={faImage} style={{ position: "absolute", left: "16px", top: "50%", transform: "translateY(-50%)", color: "#94a3b8" }} />
                  <input
                    type="text"
                    name="photo"
                    placeholder="https://images.unsplash.com/photo-..."
                    value={formData.photo}
                    onChange={handleChange}
                    required
                    style={{
                      width: "100%",
                      padding: "12px 16px 12px 44px",
                      border: "1.5px solid #cbd5e1",
                      borderRadius: "12px",
                      fontSize: "0.95rem",
                      color: "#0f172a",
                      outline: "none",
                      boxSizing: "border-box"
                    }}
                  />
                </div>
              </div>

              {/* Row 5: Description — Rich Text Editor */}
              <div>
                <label style={{ display: "block", color: "#334155", fontSize: "0.88rem", fontWeight: 700, marginBottom: "8px" }}>
                  <FontAwesomeIcon icon={faAlignLeft} style={{ marginRight: "8px", color: "#94a3b8" }} />
                  Course Description *
                </label>
                <RichTextEditor
                  value={formData.description}
                  onChange={(html) => setFormData(prev => ({ ...prev, description: html }))}
                  placeholder="Provide a comprehensive summary of what students will learn in this course..."
                />
                <p style={{ margin: "6px 0 0", fontSize: "0.78rem", color: "#94a3b8" }}>
                  Use the toolbar to add bold, italic, bullets, and alignment formatting.
                </p>
              </div>

              {/* Actions */}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "12px" }}>
                <button
                  type="button"
                  onClick={() => navigate("/DCourses")}
                  style={{
                    background: "#f1f5f9",
                    color: "#475569",
                    border: "none",
                    padding: "12px 24px",
                    borderRadius: "10px",
                    fontWeight: 700,
                    cursor: "pointer"
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    background: "linear-gradient(135deg, #4f46e5 0%, #3730a3 100%)",
                    color: "#ffffff",
                    border: "none",
                    padding: "12px 28px",
                    borderRadius: "10px",
                    fontWeight: 700,
                    cursor: loading ? "wait" : "pointer",
                    boxShadow: "0 4px 14px rgba(79, 70, 229, 0.35)",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}
                >
                  {loading ? (
                    <>
                      <FontAwesomeIcon icon={faSpinner} spin /> Creating...
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faCheckCircle} /> Publish Course
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </main>
      </section>
    </div>
  );
}

export default AddCourse;
